export default class Chat {
    
    constructor(sdk) {
        this.sdk = sdk;
        this._messages = [];
        this._nbDocs = 0;
    }

    async fetchMessages(){
        let messages = await this.sdk._fetch.get('/messages');
        this._nbDocs = 0;
        for(var i in messages.sort((a,b) => new Date(a.date) - new Date(b.date))) {
            this._messages['' + i] = messages[i]
            if(messages[i].document){
                this._nbDocs++;
            }
        }
    }

    getMessages(){
        return this._messages;
    }

    addMessage(data){
        if(data.document)
            this._nbDocs++;
        this._messages.push(data);
    }

    deleteMessage(data){
        let key = Object.keys(this._messages).filter(k => this._messages['' + k].token == data.token);
        
        if(this._messages[key].document)
            this._nbDocs--;
        delete this._messages[key];
    }

    getNbDocument(){
        return this._nbDocs;
    }

}